import { render } from "./ServicesSummary.vue?vue&type=template&id=62441c88&scoped=true"
import script from "./ServicesSummary.vue?vue&type=script&lang=js"
export * from "./ServicesSummary.vue?vue&type=script&lang=js"

import "./ServicesSummary.vue?vue&type=style&index=0&id=62441c88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62441c88"]])

export default __exports__